import React from 'react';
import PropTypes from 'prop-types';

import ArrowRight from '@decisiv/iconix/lib/components/ArrowRight';
import UserPlus from '@decisiv/iconix/lib/components/UserPlus';

import Button from '@decisiv/ui-components/lib/components/Button';
import Link from '@decisiv/ui-components/lib/components/Link';
import Message from '@decisiv/ui-components/lib/components/Message';

import { SUCCESS_PANEL } from './copy';
import { TerminalActions, TerminalPanel } from './styles';

/**
 * Shown once the user exists (Figma 787:76642).
 *
 * The username is the one the server derived from the email — the wizard never
 * asked for it — so naming it here is the admin's only chance to see it.
 *
 * The welcome-email line is not in the mockup's placeholder copy but the ticket
 * requires it: the admin never sets a password, so they need to know the user is
 * contacted automatically.
 *
 * VIEW NEW USER is disabled until the User Management tool has an edit page of its
 * own. `editPath` points at the legacy /users/:id/edit form, which sits under the
 * old portal chrome — sending the admin there from inside this wizard drops them
 * out of the tool they are working in. The link stays in place, greyed, so the
 * panel matches the mockup and re-enabling it is a one-prop change.
 */
function SuccessPanel({ onCreateAnother, user }) {
  return (
    <TerminalPanel>
      <Message
        intent="success"
        size="large"
        title={SUCCESS_PANEL.title}
        variant="vertical"
      >
        {`${SUCCESS_PANEL.body(user.username)} ${SUCCESS_PANEL.emailNotice}`}
      </Message>
      <TerminalActions>
        <Link
          disabled
          icon={ArrowRight}
          iconPosition="right"
          text={SUCCESS_PANEL.viewUser}
          to={user.editPath}
        />
        <Button
          icon={UserPlus}
          kind="secondary"
          text={SUCCESS_PANEL.createAnother}
          onClick={onCreateAnother}
        />
      </TerminalActions>
    </TerminalPanel>
  );
}

SuccessPanel.propTypes = {
  /** Resets the wizard to a blank step 1. */
  onCreateAnother: PropTypes.func.isRequired,
  user: PropTypes.shape({
    editPath: PropTypes.string,
    username: PropTypes.string,
  }).isRequired,
};

export default SuccessPanel;
